import { Eligibility } from '../../data/loanEligibility';

export const ELIGIBILITY_VALUE_MAP: Record<Eligibility, number> = {
  HIGH: 100,
  MEDIUM: 50,
  LOW: 16,
};
